import { Badge } from '@kit/ui/badge';
import { cn } from '@kit/ui/utils';

interface GlowingBadgeProps {
  children?: React.ReactNode;
  className?: string;
  innerClassName?: string;
}

const GlowingBadge = ({
  children,
  className,
  innerClassName,
}: GlowingBadgeProps) => {
  return (
    <Badge
      variant="outline"
      className={cn(
        'rounded-full !border-none bg-[#1E1D26] bg-gradient-to-b from-white/[12%] to-white/0 !p-[1px] text-white',
        className,
      )}
    >
      <div
        className={cn(
          'flex items-center justify-center space-x-2 rounded-full bg-[#1E1D26] px-3 py-1',
          innerClassName,
        )}
      >
        {children}
      </div>
    </Badge>
  );
};

export default GlowingBadge;
